import { render, staticRenderFns } from "./suggestion.vue?vue&type=template&id=f58010f0&scoped=true&"
import script from "./suggestion.vue?vue&type=script&lang=js&"
export * from "./suggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58010f0",
  null
  
)

export default component.exports